<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15" v-if="dataext">
      <v-card>
        <v-card-title class="primary--text text-uppercase">
          {{ $t("fchart.mod_e") }}<br />
          {{ $t("fchart.def_choise") }} {{ datachart.family_name }}
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="obs" v-slot="{ invalid, validate, handleSubmit }">
            <v-form ref="form">
              <v-expansion-panels accordion focusable popout>
                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_e_prt-a") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-5">
                      <v-col cols="4"> {{ $t("fchart.mod_e") }} </v-col>
                      <v-col><BaseValInput rules="max:50" v-model="dataext.question_a" v-bind:label="$t('fchart.mod_e')" /> </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col cols="4"> {{ $t("fchart.mod_e_def") }} </v-col>
                      <v-col> <BaseValArea rules="max:150" v-model="dataext.question_b" v-bind:label="$t('fchart.mod_e_def')" /> </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col cols="4">{{ $t("fchart.mod_e_why") }}</v-col>
                      <v-col> <BaseValArea rules="max:150" v-model="dataext.question_c" v-bind:label="$t('fchart.mod_e_why')" /> </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_e_prt-b") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-5">
                      <v-col cols="4"> {{ $t("fchart.mod_e") }} </v-col>
                      <v-col><BaseValInput rules="max:50" v-model="dataext.question_d" v-bind:label="$t('fchart.mod_e')" /> </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col cols="4"> {{ $t("fchart.mod_e_def") }} </v-col>
                      <v-col> <BaseValArea rules="max:150" v-model="dataext.question_e" v-bind:label="$t('fchart.mod_e_def')" /> </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col cols="4">{{ $t("fchart.mod_e_why") }}</v-col>
                      <v-col> <BaseValArea rules="max:150" v-model="dataext.question_f" v-bind:label="$t('fchart.mod_e_why')" /> </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="mt-5">
                  <v-expansion-panel-header class="info">{{ $t("fchart.mod_e_prt-c") }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-5">
                      <v-col cols="4"> {{ $t("fchart.mod_e") }} </v-col>
                      <v-col><BaseValInput rules="max:50" v-model="dataext.question_g" v-bind:label="$t('fchart.mod_e')" /> </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col cols="4"> {{ $t("fchart.mod_e_def") }} </v-col>
                      <v-col> <BaseValArea rules="max:150" v-model="dataext.question_h" v-bind:label="$t('fchart.mod_e_def')" /> </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col cols="4">{{ $t("fchart.mod_e_why") }}</v-col>
                      <v-col> <BaseValArea rules="max:150" v-model="dataext.question_i" v-bind:label="$t('fchart.mod_e_why')" /> </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>
              <div class="text-end mr-15 mt-15">
                <v-btn color="accent" @click="closeItem" class="mr-8">{{ $t("crud.close") }} </v-btn>
                <v-btn color="primary" @click="handleSubmit(saveItem)" :disabled="invalid || !validate">{{ $t("crud.change") }} </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import { ValidationObserver } from "vee-validate";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import FchartDefService from "@/services/fchart/FchartDefService";
import FchartService from "@/services/fchart/FchartService";
import BaseValInput from "@/components/input/BaseValInput";
import BaseValArea from "@/components/input/BaseValArea";
export default {
  name: "Users",
  components: {
    BaseValArea,
    BaseValInput,
    FlashMessage,
    ValidationObserver,
    ToolbarAuth,
    Navigation,
  },
  data() {
    return {
      error: null,
      dataext: {
        stat_a: "",
        stat_b: "",
      },
      datachart: {},
      statements: [],
      model: [0, 1],
    };
  },
  methods: {

    getData() {
      let Id = this.$route.params.famId;
      this.loading = true;
      FchartDefService.getDefE(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    getData2() {
      let id = this.$route.params.famId;
      this.loading = true;
      FchartService.getMain(id)
        .then((response) => {
          this.datachart = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    saveItem() {
      let Id = this.$route.params.famId;
      const payload = {
        question_a: this.dataext.question_a,
        question_b: this.dataext.question_b,
        question_c: this.dataext.question_c,
        question_d: this.dataext.question_d,
        question_e: this.dataext.question_e,
        question_f: this.dataext.question_f,
        question_g: this.dataext.question_g,
        question_h: this.dataext.question_h,
        question_i: this.dataext.question_i,

      };
      this.error = null;
      FchartDefService.postDefE(Id, payload)
        .then(() => {
          let id = this.$route.params.famId;
          this.ok = true;
          this.$router.replace({
            name: "fchartDef",
            params: { famId: id },
          });
        })
        .catch((error) => (this.error = getError(error)))
        .finally(() => {
          // eslint-disable-next-line no-undef
          EventBus.$emit("succes", true);
        });
    },

    closeItem() {
      let id = this.$route.params.famId;
      this.$router.replace({
        name: "fchartDef",
        params: { famId: id },
      });
    },
  },


  computed: {

  },
  created() {
    this.getData();
    this.getData2();
  },
};
</script>

<style scoped></style>
